import { getInitState } from 'app/utils/async-middleware';
import { actionTypes } from 'app/common/actions/kpi-groups';

const initState = getInitState();

export default (state = { ...initState }, action: any) => {
  switch (action.type) {
    case actionTypes.fetchKpiGroups: {
      const { type, ...restAction } = action;

      return {
        ...state,
        ...restAction,
      };
    }

    default:
      return state;
  }
};
